<form [formGroup]="form" class="custom-col">
  <ion-row>
    <!----- Sort Date  ------->
    <ion-col size="auto">
      <div class="sort-date-picker-container">
        <p class="date-label">
          {{ CONSTS.SORT_DATE }} <span class="required-field">*</span>
        </p>
        <app-form-date-picker
          formControlName="sortDate"
          [icon]="SRC.CALENDAR"
          [placeholder]="CONSTS.SELECT_DATE"
          [minDate]="minSortDate"
          [maxDate]="maxSortDate"
        ></app-form-date-picker>
      </div>
    </ion-col>
    <!------------------------>
    <!----- Sort Code  ------->
    <ion-col size="auto">
      <div class="sort-dropdown-container">
        <app-form-select
          formControlName="sortCode"
          [label]="CONSTS.SORT_CODE"
          [options]="optionsList"
          [placeholder]="CONSTS.SELECT"
          [required]="true"
          [hasAltHeight]="true"
        >
        </app-form-select>
      </div>
    </ion-col>
    <!------------------------>
    <!----- Location ------->
  </ion-row>
  <ion-row>
    @if (hasLocationControl) {
    <ion-col size="auto">
        <div
          class="location-input-container"
          [class.invalid-location]="
            form.get('location')?.hasError('invalidLocation') ||
            (form.get('location')?.dirty &&
              form.get('location')?.hasError('required'))
          "
        >
          <app-form-input-field
            formControlName="location"
            [label]="CONSTS.LOCATION"
            [required]="
              form.get('location')?.hasValidator(Validators.required) ?? false
            "
            [placeholder]="CONSTS.LOCATION_PLACEHOLDER"
            [maxLength]="12"
            (input)="changeToUpperCase()"
          >
          </app-form-input-field>
          @if (form.get("location")?.hasError("invalidLocation")) {
            <div class="location-invalid-error-message">
              {{ CONSTS.LOCATION_INVALID_ERROR }}
            </div>
          }
        </div>
    </ion-col>
    }
    <!------------------------>
    <!----- Tracking Number ------->
    <ion-col size="auto">
      <div class="tracking-number-container">
        <p class="tracking-number-label">
          {{ CONSTS.TRACKING_NUMBER }}
          <span class="required-field">*</span>
        </p>
        <ion-item
          class="tracking-number-item"
          lines="none"
          [ngClass]="{
            'has-error':
              form.get('trackingNumbers')?.hasError('invalidTrackingNumber') ||
              form.get('trackingNumbers')?.hasError('invalid') ||
              form
                .get('trackingNumbers')
                ?.hasError('invalidTrackingNumberFormat') ||
              (isFormSubmitted && isInvalidTrackingNumber),
            'item-end': form.get('trackingNumbers')?.value?.length > 45,
          }"
        >
          <ion-textarea
            formControlName="trackingNumbers"
            class="form-textarea"
            [ngClass]="{
              'auto-height': form.get('trackingNumbers')?.value?.length >= 45,
            }"
            cols="1"
            type="text"
            maxlength="18"
            [autoGrow]="true"
            [placeholder]="
              hasSingleTrackingNumber
                ? ''
                : hasFileUploadButton
                  ? CONSTS.ENTER_MULTIPLE_TRACKING_NUMBER
                  : CONSTS.ENTER_TRACKING_NUMBER
            "
            (keypress)="
              commonUtils.preventSpecialCharacters(
                $event,
                SpecialCharacters.ALPHABET_NUMBER_NO_SPACE
              )
            "
            (input)="resetValidationFlag()"
            (input)="changeToUpperCase()"
          ></ion-textarea>
          @if (hasFileUpload && !hasFileUploadButton) {
            <ion-button
              slot="end"
              fill="clear"
              class="upload-btn"
              [disabled]="!form.get('sortCode')?.value"
              (click)="fileUpload()"
            >
              <ion-icon [src]="SRC.UPLOAD" class="btn-icon"></ion-icon>
              <span class="btn-text">
                {{ CONSTS.FILE_UPLOAD }}
              </span>
            </ion-button>
          }
        </ion-item>

        @if (
          form.get("trackingNumbers")?.hasError("invalidTrackingNumber") ||
          form.get("trackingNumbers")?.hasError("invalid") ||
          form
            .get("trackingNumbers")
            ?.hasError("invalidTrackingNumberFormat") ||
          (isFormSubmitted && isInvalidTrackingNumber)
        ) {
          <div class="tracking-number-invalid-error-message">
            {{ CONSTS.TRACKING_NUMBER_INVALID_ERROR }}
          </div>
        }
        @if (isFormSubmitted && isTrackingNumberExistInTable) {
          <div class="tracking-number-invalid-error-message">
            {{ CONSTS.TRACKING_NUMBER_EXIST_IN_TABLE_ERROR }}
          </div>
        }
      </div>
    </ion-col>
    <!------------------------>
    @if (hasFileUploadButton) {
      <ion-col size="auto">
        <app-file-upload-button
          [disabled]="
            hasLocationControl
              ? (form.get('sortCode')?.invalid ?? true) ||
                form.get('location')?.value?.length > 0 ||
                form.get('trackingNumbers')?.value?.length > 0
              : !form.get('sortCode')?.value
          "
          (uploadClick)="fileUpload()"
        ></app-file-upload-button>
      </ion-col>
    }
    @if (hasButton) {
      <ion-col size="auto">
        <ion-button
          class="submit-btn"
          [disabled]="form.untouched || form.invalid"
          (click)="clickSubmit()"
        >
          {{ CONSTS.SUBMIT }}
        </ion-button>
      </ion-col>
    }
    <ng-content></ng-content>
  </ion-row>
</form>
